import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

/**
 * Add Customer dialog — single phone-or-email input that the cashier
 * uses to attach a customer to the in-flight Clover order (Clover-style).
 * The host component decides how to interpret the result (lookup vs
 * create + order attach + rewards) — this dialog only collects and
 * validates the input.
 *
 * Accepts either a phone number (>= 7 digits) or an email (contains @).
 * Returns the trimmed string to the caller via `dialogRef.close(value)`
 * or `null` on cancel.
 */
@Component({
  selector: 'app-add-customer-dialog',
  templateUrl: './add-customer-dialog.component.html',
  styleUrls: ['./add-customer-dialog.component.scss'],
})
export class AddCustomerDialogComponent {
  input = '';
  submitting = false;

  constructor(
    private dialogRef: MatDialogRef<AddCustomerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { rewardsEnabled?: boolean } | null,
  ) {}

  get rewardsEnabled(): boolean {
    return !!this.data?.rewardsEnabled;
  }

  get isEmail(): boolean {
    return (this.input || '').includes('@');
  }

  get isPhone(): boolean {
    if (!this.input) { return false; }
    if (this.isEmail) { return false; }
    return (this.input.replace(/[^0-9]/g, '').length) >= 7;
  }

  get canSubmit(): boolean {
    return !this.submitting && (this.isEmail || this.isPhone);
  }

  cancel(): void {
    this.dialogRef.close(null);
  }

  submit(): void {
    if (!this.canSubmit) { return; }
    this.submitting = true;
    this.dialogRef.close((this.input || '').trim());
  }
}
